export const PROCESSING_OPTIONS_KEYS = {
  standard: 'STANDARD',
  basic: 'BASIC',
  deluxe: 'DELUXE',
  premier: 'PREMIER',
  standardPackage: 'STANDARD_PACKAGE',
  ultimate: 'ULTIMATE',
  upsell: 'UPSELL',
};
